import { createIntl, createIntlCache, IntlProvider } from 'react-intl';
import enMessages from './locales/en.json';
import frMessages from './locales/fr.json';
import esMessages from './locales/es.json';

const flattenMessages = (nestedMessages, prefix = '') => {
    return Object.keys(nestedMessages).reduce((messages, key) => {
        const value = nestedMessages[key];
        const prefixedKey = prefix ? `${prefix}.${key}` : key;

        if (typeof value === 'string') {
            messages[prefixedKey] = value;
        } else {
            Object.assign(messages, flattenMessages(value, prefixedKey));
        }

        return messages;
    }, {});
};

const messages = {
    en: flattenMessages(enMessages),
    fr: flattenMessages(frMessages),
    es: flattenMessages(esMessages),
};

const cache = createIntlCache();

const intl = createIntl({
    locale: 'en', // default locale
    messages: messages['en'],
}, cache);

export { IntlProvider, intl, messages };
